/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Shortcuts_LabelInputs */

const en_timing_sync_shortcuts_label = /** @type {(inputs: Timing_Sync_Shortcuts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortcut Keys`)
};

const fr_timing_sync_shortcuts_label = /** @type {(inputs: Timing_Sync_Shortcuts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccourcis clavier`)
};

const de_timing_sync_shortcuts_label = /** @type {(inputs: Timing_Sync_Shortcuts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tastenkombinationen`)
};

const it_timing_sync_shortcuts_label = /** @type {(inputs: Timing_Sync_Shortcuts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasti di scelta rapida`)
};

const ru_timing_sync_shortcuts_label = /** @type {(inputs: Timing_Sync_Shortcuts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сочетания клавиш`)
};

const es_timing_sync_shortcuts_label = /** @type {(inputs: Timing_Sync_Shortcuts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teclas de acceso directo`)
};

const zh_cn2_timing_sync_shortcuts_label = /** @type {(inputs: Timing_Sync_Shortcuts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快捷键`)
};

const ja_timing_sync_shortcuts_label = /** @type {(inputs: Timing_Sync_Shortcuts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショートカットキー`)
};

const hi_timing_sync_shortcuts_label = /** @type {(inputs: Timing_Sync_Shortcuts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉर्टकट कुंजियाँ`)
};

const pt_pt2_timing_sync_shortcuts_label = /** @type {(inputs: Timing_Sync_Shortcuts_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teclas de atalho`)
};

/**
* | output |
* | --- |
* | "Shortcut Keys" |
*
* @param {Timing_Sync_Shortcuts_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_shortcuts_label = /** @type {((inputs?: Timing_Sync_Shortcuts_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Shortcuts_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_shortcuts_label(inputs)
	if (locale === "de") return de_timing_sync_shortcuts_label(inputs)
	if (locale === "it") return it_timing_sync_shortcuts_label(inputs)
	if (locale === "ru") return ru_timing_sync_shortcuts_label(inputs)
	if (locale === "es") return es_timing_sync_shortcuts_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_shortcuts_label(inputs)
	if (locale === "ja") return ja_timing_sync_shortcuts_label(inputs)
	if (locale === "hi") return hi_timing_sync_shortcuts_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_shortcuts_label(inputs)
	return en_timing_sync_shortcuts_label(inputs)
});